export default __webpack_public_path__ + "19866c35a58d9c06decd8171c2f1d23e.png";